<template>
  <div class="card" v-if="users.length > 0">
    <div class="card-header border-0">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0">Top Fans</h3>
        </div>
        <!-- <div class="col text-right">
          <a href="#!" class="btn btn-sm btn-primary">See all</a>
        </div>-->
      </div>
    </div>

    <div class="table-responsive">
      <base-table :data="users">
        <template slot="columns">
          <th>Profile</th>
          <th>First Name</th>
          <th>Last Name</th>
          <th>Email</th>
          <th>Phone</th>
        </template>

        <template slot-scope="{row}">
          <td class="td-profile">
            <span class="avatar avatar-sm rounded-circle">
              <img
                :src="row.profile ? row.profile : require('@/assets/default_profile_picture.png')"
              />
            </span>
          </td>
          <td>{{row.firstName}}</td>
          <td>{{row.lastName}}</td>
          <td>{{row.email}}</td>
          <td>{{row.phone}}</td>
        </template>
      </base-table>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TopFanTable',
  props: ['users']
}
</script>
<style scoped>
.table th,
.table td {
  border-top: 0.5px solid rgba(220, 220, 220, 0.3) !important;
}

</style>
